module.exports = __webpack_public_path__ + "static/img/platinum.5b45f66e.png";